/* eslint-disable */
import React, { useEffect, useState } from "react";
import { ANALYTICS_TOOL, ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import * as API from "../../framework/API/api";
import { EditPageHeader } from "../../components/EditPageHeader";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import ToastNotification from "../../components/ToastNotification";

export const AnalyticsProviderEditForm = (props) => {
    const lang = useTranslation();

    const blankDataItem = {
        ...props?.item,
        SID: props?.item?.SID ?? 0,
        AnalyticsTool: { SID: props?.item?.SID, Description: props?.item?.Description },
        Archive: props?.item?.Archive ?? false,
        ApiKey: props?.item?.Config?.ApiKey ?? "",
        Token: props?.item?.Config?.Token ?? "",
        MeasuremenId: props?.item?.Config?.MeasuremenId ?? "",
        ApiSecret: props?.item?.Config?.ApiSecret ?? "",
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [analytics, setAnalytics] = useState([]);

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = () => {
        const analyticsRes = Object.keys(ANALYTICS_TOOL).map(key => ({
            SID: ANALYTICS_TOOL[key],
            Description: key
        }));
        setAnalytics(analyticsRes);
    };

    const onChange = (e) => {
        if (e.target?.name === "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else if (e.target) {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const isValid = () => {
        if (dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.GoogleAnalytics && (!dataItem.MeasuremenId || dataItem.MeasuremenId === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_measurement_id_error_message });
            return false;
        }
        if (dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.GoogleAnalytics && (!dataItem.ApiSecret || dataItem.ApiSecret === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_api_secret_error_message });
            return false;
        }
        if (dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.MixPanel && (!dataItem.Token || dataItem.Token === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_token_error_message });
            return false;
        }
        if (dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.Flurry && (!dataItem.ApiKey || dataItem.ApiKey === "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_api_key_error_message });
            return false;
        }
        return true;
    };

    const getConfigData = (analyticsToolSID) => {
        switch (analyticsToolSID) {
            case ANALYTICS_TOOL.MixPanel:
                return { Token: dataItem.Token };  
            case ANALYTICS_TOOL.GoogleAnalytics:
                return {
                    MeasuremenId: dataItem.MeasuremenId,
                    ApiSecret: dataItem.ApiSecret,
                };
            case ANALYTICS_TOOL.Flurry:
                return { ApiKey: dataItem.ApiKey };
            default:
                return {};
        }
    };

    const handleSubmit = async () => {
        if (!isValid()) return;

        let finalData = {
            _id: dataItem._id,
            SID: dataItem.AnalyticsTool.SID,
            Description: dataItem.AnalyticsTool.Description,
            Archive: dataItem.Archive ?? false,
            Config: getConfigData(dataItem.AnalyticsTool.SID),
            checkDuplicate: true,
            query: [["Description", "=", dataItem.AnalyticsTool.Description]],
        };
        console.log(finalData);

        let res = await API.saveData(ENTITYNAME.AnalyticsProviders, finalData);
        if (res.success) {
            let logData = {
                event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT,
                module: MODULE.ANALYTICS_PROVIDER,
                data: res.data,
                message: res.message
            };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.AnalyticsProviders);
            props.cancelEdit();
            props.refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    return (
        <BossDialog
            title={lang.create_analytics_provider_dialog_header}
            onClose={props.cancelEdit}
            width={"50vw"}
        >
            <div className="row">
                <div className="col-12">
                    <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                    <div className="row mt-2">
                        <div className="col-6">
                            <label>{lang.name_label}</label>
                            <DropDownList
                                data={analytics}
                                name="AnalyticsTool"
                                dataItemKey="SID"
                                textField="Description"
                                className="bg-white"
                                value={dataItem.AnalyticsTool}
                                onChange={onChange}
                                disabled={!!props?.item?._id} 
                            />
                        </div>
                        {dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.MixPanel && (
                            <div className="col-6">
                                <label>{lang.token_label} *</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Token"
                                    value={dataItem.Token}
                                    onChange={onChange}
                                />
                            </div>
                        )}
                        {dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.Flurry && (
                            <div className="col-6">
                                <label>{lang.api_key_label} *</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="ApiKey"
                                    value={dataItem.ApiKey}
                                    onChange={onChange}
                                />
                            </div>
                        )}
                    </div>
                    {dataItem.AnalyticsTool.SID === ANALYTICS_TOOL.GoogleAnalytics && (
                        <div className="row mt-2">
                            <div className="col-6">
                                <label>{lang.measurement_id_label} *</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="MeasuremenId"
                                    value={dataItem.MeasuremenId}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-6">
                                <label>{lang.api_secret_label} *</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="ApiSecret"
                                    value={dataItem.ApiSecret}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    )}
                    <div className="row mt-3">
                        <div className="col">
                            <input
                                type="checkbox"
                                name="Archive"
                                checked={dataItem.Archive}
                                onChange={onChange}
                            />
                            <label className="pl-2">{lang.archive}</label>
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog>
    );
};
